import React from "react";
import { useTranslate } from "@tolgee/react";
import {
  ReadyScreen, ReadyEmoji, ReadyTitle, ReadySubtitle, ReadyBtn, ReadyBtnOutline,
} from "./shared/OnboardingStyles";

const OnboardingReadyScreen = ({ name, onChat, onCall }) => {
  const { t } = useTranslate();
  return (
    <ReadyScreen>
      <ReadyEmoji>🎉</ReadyEmoji>
      <ReadyTitle>{t("authentication.onboarding.ready_title", { name })}</ReadyTitle>
      <ReadySubtitle>{t("authentication.onboarding.ready_subtitle")}</ReadySubtitle>
      <ReadyBtn onClick={onChat}>{t("authentication.onboarding.start_chat")}</ReadyBtn>
      <ReadyBtnOutline onClick={onCall}>{t("authentication.onboarding.make_call")}</ReadyBtnOutline>
    </ReadyScreen>
  );
};

export default OnboardingReadyScreen;
